export default __webpack_public_path__ + "static/media/FatiguePrevention.1f265795.pdf";